import React from 'react'
import Form from '@blocks/Form'
import { ReactComponent as EmailIcon } from '@icons/email.svg'
import { ReactComponent as PasswordIcon } from '@icons/password.svg'
import { Link, useHistory } from 'react-router-dom'
import useTitle from '@hooks/useTitle'
import Button from '@components/blocks/Button'
import Input from '@components/blocks/Input'
import { notify, route } from '@helpers'
import api from '@api'
import useAuth from '@hooks/useAuth'
import useAuthTemplate from '@auth/components/template/hooks/useAuthTemplate'
import styled from 'styled-components'

export default function SigninPage() {
    const history = useHistory()
    const { setUser, refreshUser } = useAuth()
    
    useTitle("Sign in")
    useAuthTemplate({
        social: true,
        footer: <p><Link to={route("signup")}>Register</Link><span> if you don't have an account</span></p>
    })

    const handleSuccess = async (data: string | Helpers.User) => {
        if (typeof data === "string") {
            notify(data)
            await refreshUser()
            history.push(route('app'))
        } else {
            setUser(data)
        }
    }

    return (
        <Form action={api.login} handleSuccess={handleSuccess} method="post">
            <Input id="email" type="email" name="email" height="l" placeholder="example@email.com" label="Email" required icon={<EmailIcon />} />
            <Input minLength={8} id="password" type="password"  height="l" name="password" placeholder="xxxxxxxx" label="Password" required icon={<PasswordIcon />} />
            <ForgotWrapper>
                <Button type="tertiary" to={route("forgot")} element={"link"}>Forgot password?</Button>
            </ForgotWrapper>
            <Button element="submit">Sign in</Button>
        </Form>
    )
}

// STYLES
const ForgotWrapper = styled.div`
    margin-top: -5px;
    margin-bottom: -5px;
    display: flex;
    justify-content: flex-end;
`